module.exports = __webpack_public_path__ + "static/media/53.a84c86c8.png";